import React from 'react';
import { Text } from '@clockout-dev/design-elements';
import { formatCompactCurrency } from '../../../utils/numbers';
import styles from './styles/agingBucketRow.module.scss';

/**
 * Single aging bucket row: label on the left, amount on the right, and
 * a horizontal progress bar underneath. Pure presentational.
 */
function AgingBucketRow({ label, amount, percent }) {
    const safePercent = Math.max(0, Math.min(100, percent ?? 0));

    return (
        <div className={styles.row}>
            <div className={styles.head}>
                <Text as="span" size="xs" className={styles.label}>{label}</Text>
                <Text as="span" size="xs" className={styles.amount}>
                    {formatCompactCurrency(amount)}
                </Text>
            </div>
            <div className={styles.track}>
                <span
                    className={styles.fill}
                    style={{ width: `${safePercent}%` }}
                    aria-hidden="true"
                />
            </div>
        </div>
    );
}

export default AgingBucketRow;
